
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/wati",
      function () {
        return require("private-next-pages/compare/wati.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/wati"])
      });
    }
  